module.exports = __webpack_public_path__ + "img/pic_13.1f1cb299.jpg";